<template>
  <div class="col-6 col-lg-3">

        <div class="slider__container box_curved_small">
            <router-link :to="{ name: 'offtaker.mycrop', params: { id: crop.id, name: crop.name }}">
                <div class="slider__container__img">
                    <img :src="crop.image_url" v-if="crop.image_url" />
                    <img v-else :src="`${$baseImageUrl}/banners/auth_bg.jpg`" />
                </div>
            </router-link>
            <div class="slider__container__content color__white">
                <router-link :to="{ name: 'offtaker.mycrop', params: { id: crop.id, name: crop.name }}">
                    <h4 class="font-bold">{{crop.name}}</h4>
                    <div class="listmeta color__white">
                        <span class="listMetaItem">{{crop.sellers_count}} Sellers</span>
                        <span class="listMetaseperator">•</span>
                        <span class="listMetaItem">{{crop.total_yield / 1000 | formatNumber}}
                        tons
                        </span>
                    </div>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['crop'],
    data() {
        return {

        }
    }
}
</script>

<style>

</style>